import React from "react";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
function Loader() {
    return (<main className="page-loader" aria-live="polite" aria-busy="true">
      <Trans i18nKey="loading">Loading</Trans>
    </main>);
}
export default Loader;
